export default __webpack_public_path__ + "static/media/ParentsMINIAPPSbg-fixed.683ee999.mp4";